/**
 * @fileoverview Civil & Criminal Offences: deferred state on bankruptcy jobs (MOR-1260)
 * @module components/jobs/phases/review/civilCriminalOffences/OffencesDeferredState
 *
 * The offence workspace characterises Corporations Act offences for company
 * officers. Bankruptcy Act offence heads (Part XIV) are not built, so on a
 * personal or business bankruptcy the section renders this explanation
 * instead of the master table. Navigation stays; nothing schedules.
 */

import { ArrowLeft, Scale } from "lucide-react";
import { Button } from "@/ui/primitives/button";

export function OffencesDeferredState({ onBack }: { onBack: () => void }) {
  return (
    <div className="flex min-h-full flex-1 flex-col bg-muted p-6">
      <div className="mb-4 flex items-center gap-3">
        <Button
          variant="outline"
          size="sm"
          onClick={onBack}
          className="gap-1.5"
        >
          <ArrowLeft className="h-4 w-4" />
          Back to Investigations
        </Button>
        <h1 className="text-lg font-semibold">Civil & Criminal Offences</h1>
      </div>
      <div className="mx-auto mt-10 max-w-xl rounded-lg border bg-background p-6 text-sm">
        <div className="mb-3 flex items-center gap-2">
          <Scale className="h-5 w-5 text-muted-foreground" />
          <h2 className="font-semibold">
            Offence heads are not yet modelled for personal bankruptcy
          </h2>
        </div>
        <p className="text-muted-foreground">
          This workspace characterises Corporations Act offences and civil
          penalties for company officers. The Bankruptcy Act offence provisions
          (Part XIV) have not been built, and offence referrals on a bankruptcy
          sit with AFSA and the Inspector-General in Bankruptcy rather than
          driving the trustee&apos;s recovery work.
        </p>
        <p className="mt-3 text-muted-foreground">
          Books &amp; Records and Solvency Analysis still run on this job, and
          Recoverable Transactions covers the s&nbsp;120, s&nbsp;121 and
          s&nbsp;122 heads.
        </p>
      </div>
    </div>
  );
}
